module.exports = __webpack_public_path__ + "static/media/cloudservices.8c393807.png";